"use client";

import { c as _c } from "react/compiler-runtime";
import { toggleCommentReaction } from "@/actions/comment";
import { CommentActionArea, CommentContainer, CommentContentArea, CommentHeader, CommentInfoHeader, CommentProfileImageArea, CommentText } from "@/components/fancy/comment";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { queryClient } from "@/providers/react-query";
import { getReplies } from "@/queries-alt/with-use-server";
import { formatUserFullName } from "@/utils/formatters";
import { tryCatch } from "@/utils/validators";
import { useAuth } from "@clerk/nextjs";
import { formatDistanceToNowStrict } from "date-fns";
import { ThumbsDown, ThumbsUp } from "flowbite-react-icons/outline";
import { ThumbsDown as ThumbsDownFilled, ThumbsUp as ThumbsUpFilled } from "flowbite-react-icons/solid";
import { toast } from "sonner";
import { DotSymbol } from "../fancy/html-symbol";
import ReplyMenu from "./reply-menu";
type ReplyItemProps = {
  reply: Awaited<ReturnType<typeof getReplies>>["replies"][number];
};
export default function ReplyItem(t0) {
  const $ = _c(67);
  const {
    reply
  } = t0;
  const {
    userId
  } = useAuth();
  let t1;
  if ($[0] !== reply.id || $[1] !== reply.parentCommentId) {
    t1 = async function handleToggleLike() {
      const {
        error
      } = await tryCatch(toggleCommentReaction(reply.id, "LIKE"));
      if (error) {
        toast.error(error.message);
        return;
      }
      queryClient.invalidateQueries({
        queryKey: [`get-replies:${reply.parentCommentId}`]
      });
    };
    $[0] = reply.id;
    $[1] = reply.parentCommentId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleToggleLike = t1;
  let t2;
  if ($[3] !== reply.id || $[4] !== reply.parentCommentId) {
    t2 = async function handleToggleDislike() {
      const {
        error: error_0
      } = await tryCatch(toggleCommentReaction(reply.id, "DISLIKE"));
      if (error_0) {
        toast.error(error_0.message);
        return;
      }
      queryClient.invalidateQueries({
        queryKey: [`get-replies:${reply.parentCommentId}`]
      });
    };
    $[3] = reply.id;
    $[4] = reply.parentCommentId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleToggleDislike = t2;
  let t3;
  if ($[6] !== reply.user.profile) {
    t3 = reply.user.profile?.imageUrl && <AvatarImage src={reply.user.profile.imageUrl} alt={`Profile picture of ${formatUserFullName(reply.user.profile.firstName, reply.user.profile.lastName)}`} />;
    $[6] = reply.user.profile;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = reply.user.profile?.firstName?.[0];
  const t5 = reply.user.profile?.lastName?.[0];
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = formatUserFullName(t4, t5);
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <AvatarFallback>{t6}</AvatarFallback>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t3 || $[14] !== t7) {
    t8 = <CommentProfileImageArea><Avatar>{t3}{t7}</Avatar></CommentProfileImageArea>;
    $[13] = t3;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = reply.user.profile?.firstName;
  const t10 = reply.user.profile?.lastName;
  let t11;
  if ($[16] !== t10 || $[17] !== t9) {
    t11 = formatUserFullName(t9, t10);
    $[16] = t10;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11) {
    t12 = <p className="font-semibold">{t11}</p>;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <DotSymbol />;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== reply.createdAt) {
    t14 = formatDistanceToNowStrict(reply.createdAt, {
      addSuffix: true
    });
    $[22] = reply.createdAt;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t14) {
    t15 = <p>{t14}</p>;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t12 || $[27] !== t15) {
    t16 = <CommentInfoHeader>{t12}{t13}{t15}</CommentInfoHeader>;
    $[26] = t12;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== reply || $[30] !== userId) {
    t17 = reply.userId === userId && <ReplyMenu reply={reply} />;
    $[29] = reply;
    $[30] = userId;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t16 || $[33] !== t17) {
    t18 = <CommentHeader>{t16}{t17}</CommentHeader>;
    $[32] = t16;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== reply.content) {
    t19 = <CommentText>{reply.content}</CommentText>;
    $[35] = reply.content;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== reply.userReaction) {
    t20 = reply.userReaction === "LIKE" ? <ThumbsUpFilled size={20} /> : <ThumbsUp size={20} strokeWidth={1.5} />;
    $[37] = reply.userReaction;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== handleToggleLike || $[40] !== t20) {
    t21 = <Button variant="ghost" size="icon" className="flex h-auto w-auto items-center gap-2 p-1" onClick={handleToggleLike}>{t20}</Button>;
    $[39] = handleToggleLike;
    $[40] = t20;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== reply.likeCount) {
    t22 = reply.likeCount > 0 && <span className="text-xs">{reply.likeCount}</span>;
    $[42] = reply.likeCount;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== t21 || $[45] !== t22) {
    t23 = <div className="flex items-center">{t21}{t22}</div>;
    $[44] = t21;
    $[45] = t22;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== reply.userReaction) {
    t24 = reply.userReaction === "DISLIKE" ? <ThumbsDownFilled size={20} /> : <ThumbsDown size={20} strokeWidth={1.5} />;
    $[47] = reply.userReaction;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== handleToggleDislike || $[50] !== t24) {
    t25 = <Button variant="ghost" size="icon" className="flex h-auto w-auto items-center gap-2 p-1" onClick={handleToggleDislike}>{t24}</Button>;
    $[49] = handleToggleDislike;
    $[50] = t24;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  let t26;
  if ($[52] !== reply.dislikeCount) {
    t26 = reply.dislikeCount > 0 && <span className="text-xs">{reply.dislikeCount}</span>;
    $[52] = reply.dislikeCount;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[54] !== t25 || $[55] !== t26) {
    t27 = <div className="flex items-center">{t25}{t26}</div>;
    $[54] = t25;
    $[55] = t26;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] !== t23 || $[58] !== t27) {
    t28 = <CommentActionArea className="mt-1"><div className="flex items-center">{t23}{t27}</div></CommentActionArea>;
    $[57] = t23;
    $[58] = t27;
    $[59] = t28;
  } else {
    t28 = $[59];
  }
  let t29;
  if ($[60] !== t18 || $[61] !== t19 || $[62] !== t28) {
    t29 = <CommentContentArea>{t18}{t19}{t28}</CommentContentArea>;
    $[60] = t18;
    $[61] = t19;
    $[62] = t28;
    $[63] = t29;
  } else {
    t29 = $[63];
  }
  let t30;
  if ($[64] !== t29 || $[65] !== t8) {
    t30 = <CommentContainer className="p-0">{t8}{t29}</CommentContainer>;
    $[64] = t29;
    $[65] = t8;
    $[66] = t30;
  } else {
    t30 = $[66];
  }
  return t30;
}